import './src/styles/global.css';
import React from 'react';
import { Script } from 'gatsby';
import { ToastProvider } from './src/contexts/ToastContext';

export const wrapRootElement = ({ element }) => (
  <ToastProvider>{element}</ToastProvider>
);

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <Script
      src="https://www.googletagmanager.com/gtag/js?id=G-Z9C1RKZM16"
      strategy="idle"
    />
    <Script id="gtag-config-1" strategy="idle">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-Z9C1RKZM16');
      `}
    </Script>
    <Script
      src="https://www.googletagmanager.com/gtag/js?id=AW-804925509"
      strategy="idle"
    />
    <Script id="gtag-config-2" strategy="idle">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-804925509');
      `}
    </Script>
    <Script id="gtm-script" strategy="idle">
      {`
        !function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        }(window,document,'script','dataLayer','GTM-P3NWLD3');
      `}
    </Script>
    <Script id="fb-pixel" strategy="idle">
      {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '895770941489500');
        fbq('track', 'PageView');
      `}
    </Script>
    <Script id="microsoft-clarity" strategy="idle">
      {`
        (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "iv04dq5no2");
      `}
    </Script>
    <Script src="/js/donorbox-widget.js" strategy="post-hydrate" />
    {/* <Script
      src="https://donorbox.org/install-popup-button.js"
      strategy="post-hydrate"
    /> */}
    <Script id="donorbox-config" strategy="post-hydrate">
      {`window.DonorBox = { widgetLinkClassName: 'dbox-donation-button' };`}
    </Script>
  </>
);
